import React from 'react'
import {
  IconClose,
  IconMail,
  Stack,
  TextField,
  TextFieldButton,
} from 'src/viewLayer/components/DesignSystem'
import { t } from 'src/viewLayer/helpers/translations'

export default ({
  ariaDescribedby = 'message-uat-email-input-field',
  clearValue,
  disabled,
  errorKey,
  isFocused,
  onChangeHandler,
  value,
}) => (
  <Stack className="InputFrame" gap={16}>
    <TextField
      actionButton={
        value ? (
          <TextFieldButton icon={<IconClose />} onClick={() => clearValue()} title={'Clear'} />
        ) : null
      }
      additionalText={errorKey && t(errorKey)}
      ariaDescribedby={ariaDescribedby}
      autoComplete="email"
      autoFocus={isFocused}
      color="lightened"
      disabled={disabled}
      fullWidth={true}
      icon={<IconMail />}
      id="uat-email-input-field"
      onChange={onChangeHandler}
      placeholder={t('email.placeholder')}
      state={errorKey ? 'error' : 'default'}
      type="email"
      value={value}
    />
  </Stack>
)
